import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "react-flexbox-grid";

export default class DojoGrid extends Component {
  render() {
    const { style, children, className } = this.props;

    const gridStyles = {
      position: "relative",
      width: "100%",
      paddingTop: "0",
      paddingRight: "0",
      paddingBottom: "0",
      paddingLeft: "0",
      ...style,
    };

    return (
      <Grid className={className} style={gridStyles} fluid>
        {children}
      </Grid>
    );
  }
}

DojoGrid.propTypes = {
  style: PropTypes.object,
};
